import QRScanner from "../components/QRScanner";
import { connect } from "react-redux";
import React, {useEffect, useState} from "react";
import { IAsset } from "../models/IAsset";
import { assetProbe } from "../actions/assetActions";
import Asset from "../components/asset";
import {ClipboardList, Home, ScanEye} from "lucide-react";
import {useTranslation} from "react-i18next";
import {SingleValue} from "react-select";
import {Option} from "../models/types";
import {useNavigate} from "react-router-dom";

interface Props {
    dispatch: Function;
    asset?: IAsset;
}

const Request: React.FC<Props> = ({ dispatch, asset }) => {
    const [ pValue, setPValue ] = useState<Option>({label: '', value: ''});
    const [ showAdvance, setShowAdvance ] = useState(false);

    const nav = useNavigate();
    const { i18n } = useTranslation();
    // @ts-ignore
    const t = (txt: string) => i18n.t(txt);

    const onResult = (data: string, skipDecode = false) => {
        console.log('detected ', data);
        let urlObj;
        let assetValue;

        if(!skipDecode){
            try {
                urlObj = new URL(data);
                // Use URLSearchParams to get the 'asset' parameter value
                assetValue = urlObj.searchParams.get("asset");
            } catch (TypeError) {
                assetValue = data;
            }
        } else {
            assetValue = data
        }

        if (assetValue) {
            dispatch(assetProbe(assetValue, skipDecode));
            setShowAdvance(false)
        }
    };

    const handleSetValue = (value: SingleValue<Option>) => {
        if(value)
        {
            setPValue({label: value.label, value: value.value});
            onResult(value.value as string, true)
        }
    }

    // Scroll to the top whenever asset is not set
    useEffect(() => {
        if (!asset) {
            window.scrollTo(0, 0);
        } else {
            console.log('we have an asset:', asset);
        }

    }, [asset]);

    return (
        <>
            <div style={{marginBottom: -10}}>
                    <Home style={{marginTop: "-10px", color: "#0e6efd"}} onClick={() => nav('/')}></Home>
                    <span style={{marginLeft: 5, fontSize: 20}}>≫</span>
                    <span style={{marginBottom: '10px', marginRight: '10px',
                        fontSize: '18px', fontWeight: 'bolder',
                        padding: '5px'
                    }}>{t('inquiry')}</span>
            </div>


            <QRScanner onResult={onResult} scanOnload={false} />

            {asset !== undefined ? <Asset asset={asset} /> : <></>}
        </>
    );
};

const mapStateToProps = (state: any) => ({
    asset: state.asset.asset,
});

export default connect(mapStateToProps)(Request);
